import { render, staticRenderFns } from "./CustomScript.vue?vue&type=template&id=3fe2f37c&scoped=true&"
import script from "./CustomScript.vue?vue&type=script&lang=ts&"
export * from "./CustomScript.vue?vue&type=script&lang=ts&"
import style0 from "./CustomScript.vue?vue&type=style&index=0&id=3fe2f37c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe2f37c",
  null
  
)

export default component.exports